import { render, staticRenderFns } from "./transactionInfomation.vue?vue&type=template&id=cf9d7d4c&scoped=true&"
import script from "./transactionInfomation.vue?vue&type=script&lang=js&"
export * from "./transactionInfomation.vue?vue&type=script&lang=js&"
import style0 from "./transactionInfomation.vue?vue&type=style&index=0&id=cf9d7d4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9d7d4c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf9d7d4c')) {
      api.createRecord('cf9d7d4c', component.options)
    } else {
      api.reload('cf9d7d4c', component.options)
    }
    module.hot.accept("./transactionInfomation.vue?vue&type=template&id=cf9d7d4c&scoped=true&", function () {
      api.rerender('cf9d7d4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/after-sale/upgrade/components/transactionInfomation.vue"
export default component.exports